"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
class Logger {
    destinations = [];
    constructor(destinations = []) {
        this.destinations = destinations;
    }
    addDestination(destination) {
        this.destinations.push(destination);
    }
    log(level, message, context) {
        const entry = {
            level,
            message,
            timestamp: new Date(),
            context,
        };
        for (const destination of this.destinations) {
            destination.log(entry);
        }
    }
    debug(msg, context) {
        this.log('debug', msg, context);
    }
    info(msg, context) {
        this.log('info', msg, context);
    }
    warn(msg, context) {
        this.log('warn', msg, context);
    }
    error(msg, context) {
        this.log('error', msg, context);
    }
}
exports.Logger = Logger;
